import { render, staticRenderFns } from "./AsideViewWebinar.vue?vue&type=template&id=0a70cc6c&scoped=true&"
import script from "./AsideViewWebinar.vue?vue&type=script&lang=js&"
export * from "./AsideViewWebinar.vue?vue&type=script&lang=js&"
import style0 from "./AsideViewWebinar.vue?vue&type=style&index=0&id=0a70cc6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a70cc6c",
  null
  
)

export default component.exports